export default __webpack_public_path__ + "static/media/lab4.9e25d589.jpeg";